<template lang="pug">
  .points-counter
    .points-counter__title {{ count }}
    p.points-counter__text очков
</template>

<script>
export default {
  name: 'PointsCounter',
  props: ['count'],
};
</script>

<style lang="scss">
  .points {
    &-counter {
      color: $clr-darkMain;
      text-align: right;
      &__title {
        @include typo-h1;
        @media (max-width: $max-width-xs) {
          @include typo-button;
        }
      }
      &__text {
        @include typo-h2;
        margin-top: -5px;
        @media (max-width: $max-width-xs) {
          @include typo-add($w: bold);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Interface/PointsCounter.vue